import { inclusiveAudio } from "./inclusiveAudio";
import { inclusiveFrontSize, inclusiveFrontsStartPage } from "./inclusiveFrontSize";

/**
 * Ініціалізація логіки інклюзивної панелі (варіант A: React керує відкриттям)
 * Повертає cleanup()
 */
export function initInclusiveScripts() {
  var listeners = [];

  function on(el, event, handler, options) {
    if (!el) return;
    el.addEventListener(event, handler, options || false);
    listeners.push({ el: el, event: event, handler: handler, options: options });
  }

  function offAll() {
    for (var i = 0; i < listeners.length; i++) {
      try {
        var it = listeners[i];
        it.el.removeEventListener(it.event, it.handler, it.options || false);
      } catch (e) {
        // ignore
      }
    }
    listeners = [];
  }

  function isMobileScreen() {
    return window.innerWidth < 768;
  }

  // THEMES
  function setTheme(theme) {
    // theme: "" | "inclusive-monochrome" | "inclusive-dark"
    document.body.classList.remove("inclusive-monochrome");
    document.body.classList.remove("inclusive-dark");
    if (theme === "inclusive-monochrome") document.body.classList.add("inclusive-monochrome");
    if (theme === "inclusive-dark") document.body.classList.add("inclusive-dark");

    if (!theme) localStorage.removeItem("theme");
    else localStorage.setItem("theme", theme);

    // update active states
    var ids = [
      "inclusive_blue", "inclusive_monochrome", "inclusive_dark",
      "inclusive_blue_mob", "inclusive_monochrome_mob", "inclusive_dark_mob"
    ];
    for (var i = 0; i < ids.length; i++) {
      var b = document.getElementById(ids[i]);
      if (b) b.classList.remove("inclusive-panel-colors-btns-item-active");
    }
    if (!theme) {
      var blue = document.getElementById("inclusive_blue") || document.getElementById("inclusive_blue_mob");
      if (blue) blue.classList.add("inclusive-panel-colors-btns-item-active");
    } else if (theme === "inclusive-monochrome") {
      var mono = document.getElementById("inclusive_monochrome") || document.getElementById("inclusive_monochrome_mob");
      if (mono) mono.classList.add("inclusive-panel-colors-btns-item-active");
    } else if (theme === "inclusive-dark") {
      var dark = document.getElementById("inclusive_dark") || document.getElementById("inclusive_dark_mob");
      if (dark) dark.classList.add("inclusive-panel-colors-btns-item-active");
    }
  }

  function toggleImages(shouldHide) {
    var imgs = document.querySelectorAll("img:not([data-not-hide-image])");
    for (var i = 0; i < imgs.length; i++) {
      var im = imgs[i];
      if (shouldHide) im.classList.add("hide-image");
      else im.classList.remove("hide-image");
    }
    var bg = document.getElementById("contentfirstpage");
    var bg1 = document.getElementById("contentfirstpage1");
    if (bg && bg1) {
      if (shouldHide) bg.classList.add("hide-background");
      if (shouldHide) bg1.classList.add("hide-background");

      else { bg.classList.remove("hide-background");
         bg1.classList.remove("hide-background")};
    }
    var wrap = document.querySelector(".content-wrap-main") || document.querySelector(".sv-quote");
    if (wrap) {
      if (shouldHide) wrap.classList.add("hide-before-after-image");
      else wrap.classList.remove("hide-before-after-image");
    }
  }

  // Restore
  function restore() {
    var theme = localStorage.getItem("theme");
    if (theme) setTheme(theme);
    else setTheme("");

    var hideImages = localStorage.getItem("hide_images") === "true";
    var cb = document.getElementById(isMobileScreen() ? "inclusive_images_checkbox_mob" : "inclusive_images_checkbox");
    if (cb) cb.checked = !hideImages;
    toggleImages(hideImages);

    // fonts
    try {
      inclusiveFrontsStartPage(isMobileScreen());
    } catch (e) {}
  }

  // Theme listeners
  on(document.getElementById("inclusive_blue"), "click", function () { setTheme(""); });
  on(document.getElementById("inclusive_monochrome"), "click", function () {
    var cur = localStorage.getItem("theme");
    if (cur === "inclusive-monochrome") setTheme("");
    else setTheme("inclusive-monochrome");
  });
  on(document.getElementById("inclusive_dark"), "click", function () {
    var cur = localStorage.getItem("theme");
    if (cur === "inclusive-dark") setTheme("");
    else setTheme("inclusive-dark");
  });

  // mob
  on(document.getElementById("inclusive_blue_mob"), "click", function () { setTheme(""); });
  on(document.getElementById("inclusive_monochrome_mob"), "click", function () {
    var cur = localStorage.getItem("theme");
    if (cur === "inclusive-monochrome") setTheme("");
    else setTheme("inclusive-monochrome");
  });
  on(document.getElementById("inclusive_dark_mob"), "click", function () {
    var cur = localStorage.getItem("theme");
    if (cur === "inclusive-dark") setTheme("");
    else setTheme("inclusive-dark");
  });

  // images toggle
  var cbDesktop = document.getElementById("inclusive_images_checkbox");
  var cbMob = document.getElementById("inclusive_images_checkbox_mob");
  on(cbDesktop, "change", function (e) {
    var shouldHide = !e.target.checked;
    toggleImages(shouldHide);
    localStorage.setItem("hide_images", shouldHide ? "true" : "false");
    if (cbMob) cbMob.checked = !shouldHide;
  });
  on(cbMob, "change", function (e) {
    var shouldHide = !e.target.checked;
    toggleImages(shouldHide);
    localStorage.setItem("hide_images", shouldHide ? "true" : "false");
    if (cbDesktop) cbDesktop.checked = !shouldHide;
  });

  // reset
  on(document.getElementById("remove_all_inclusive_settings"), "click", function () {
    localStorage.removeItem("theme");
    localStorage.removeItem("access_font");
    localStorage.removeItem("hide_images");
    window.location.reload();
  });
  on(document.getElementById("remove_all_inclusive_settings_mob"), "click", function () {
    localStorage.removeItem("theme");
    localStorage.removeItem("access_font");
    localStorage.removeItem("hide_images");
    window.location.reload();
  });

  // hide panel buttons (defensive — React manages open state)
  // on(document.getElementById("hide_panel_controls"), "click", function () {
  //   var panels = document.querySelectorAll(".inclusive-panel");
  //   for (var i = 0; i < panels.length; i++) panels[i].classList.remove("inclusive-panel-open");
  // });
  on(document.getElementById("hide_panel_controls_mob"), "click", function () {
    var panels = document.querySelectorAll(".inclusive-panel");
    for (var i = 0; i < panels.length; i++) panels[i].classList.remove("inclusive-panel-open");
  });

  // init font and audio, and capture their cleanup functions if they return them
  var audioCleanup = null;
  var fontCleanup = null;
  try {
    var maybeFont = inclusiveFrontSize(isMobileScreen());
    if (typeof maybeFont === "function") fontCleanup = maybeFont;
  } catch (e) {}

  try {
    var maybeAudio = inclusiveAudio(isMobileScreen());
    if (typeof maybeAudio === "function") audioCleanup = maybeAudio;
  } catch (e) {}

  // also call front starts
  try {
    inclusiveFrontsStartPage(isMobileScreen());
  } catch (e) {}

  // on resize re-init some things (debounced small)
  var resizeTimeout = null;
  function onResize() {
    if (resizeTimeout) window.clearTimeout(resizeTimeout);
    resizeTimeout = window.setTimeout(function () {
      try {
        inclusiveFrontSize(isMobileScreen());
      } catch (e) {}
      try {
        inclusiveAudio(isMobileScreen());
      } catch (e) {}
    }, 150);
  }
  on(window, "resize", onResize);

  // Restore UI state from storage
  restore();

  // cleanup aggregator
  function cleanup() {
    // call audio/font cleanups first
    try {
      if (typeof audioCleanup === "function") audioCleanup();
    } catch (e) {}
    try {
      if (typeof fontCleanup === "function") fontCleanup();
    } catch (e) {}
    // off all listeners registered here
    try {
      offAll();
    } catch (e) {}
    try {
      window.removeEventListener("unload", cleanup);
    } catch (e) {}
  }

  // ensure unload cleanup
  try {
    window.addEventListener("unload", cleanup);
  } catch (e) {}

  return cleanup;
}



// WEBPACK FOOTER //
// src/components/inclusive/utils/inclusiveScripts.js